import 'htmx.org'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
 
Alpine.plugin(collapse)
// Add Alpine instance to window object.
window.Alpine = Alpine

// Start Alpine.
Alpine.start()
Alpine.store('menu', {
						open: false,
						toggle() {
							this.open = !this.open;
							window.dispatchEvent(new CustomEvent('menu-toggle'));
						}
					});

/** @type {import('tailwindcss').Config} */
module.exports = {
  content: [
    "./src/**/*.{html,js,ts,jsx,tsx,templ}",
    "./templates/**/*.{html,templ}",
    "./views/**/*.{html,templ}",
    "./**/*.templ",
  ],
  darkMode: 'class',
  theme: {
    extend: {
      colors: {
        'dark-navy': '#0a0e27',
        'dark-blue': '#1a1f3a',
        'accent-blue': '#3b82f6',
        'accent-cyan': '#06b6d4',
      },
    },
  },
  plugins: [],
}